(function () {
  'use strict';

  angular
    .module('app')
    .component('productCategoryPrepaymentSettings', productCategoryPrepaymentSettings());

  function productCategoryPrepaymentSettings() {
    return {
      bindings: {
        productCategory: '<',
        prepaymentSettings: '<',
        onPrepaymentSettingsSaved: '&',
        onPrepaymentSettingsCanceled: '&',
      },
      controller: ProductCategoryPrepaymentSettingsComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/product-categories/components/' +
        'product-category-prepayment-settings/product-category-prepayment-settings.component.html',
    };
  }

  ProductCategoryPrepaymentSettingsComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ProductCategoryService',
  ];

  function ProductCategoryPrepaymentSettingsComponent(config, UtilService, ProductCategoryService) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.prepaymentPaymentTimes = config.PREPAYMENT_PAYMENT_TIMES;

    vm.$onInit = function () {
      // Initializers
      setPrepaymentSettings();
    };

    // public methods
    // -----------------------
    vm.validatePrepaymentSettingsElements = function () {
      vm.hasElementsAlike = false;
      vm.elementsAlike = [];

      let total = 0;

      vm.prepaymentSettings.map((item, indexItem) => {
        vm.prepaymentSettings.forEach((element, indexElement) => {
          if (
            (angular.equals(item, element) ||
              (item.payment_time === vm.prepaymentPaymentTimes[2].payment_time &&
                element.payment_time === vm.prepaymentPaymentTimes[2].payment_time) ||
              (item.payment_time === vm.prepaymentPaymentTimes[0].payment_time &&
                element.payment_time === vm.prepaymentPaymentTimes[0].payment_time)) &&
            indexItem !== indexElement
          ) {
            vm.elementsAlike.push(indexElement);
            vm.hasElementsAlike = true;
          }
        });

        total += parseFloat(item.value || 0);
      });

      vm.totalPercentage = total;
    };

    vm.cancelApplyPrepaymentSettings = function () {
      vm.onPrepaymentSettingsCanceled();
    };

    vm.addNewPrepaymentSetting = function () {
      vm.prepaymentSettings.push({
        payment_time: vm.prepaymentPaymentTimes[0].payment_time, // on_booking_date
        days_before_service: 1,
        value: 1,
      });

      vm.validatePrepaymentSettingsElements();

      // return vm.prepaymentSettings; // not nedded
    };

    vm.removePrepaymentSetting = function (index) {
      vm.prepaymentSettings.splice(index, 1);

      vm.validatePrepaymentSettingsElements();

      // return vm.prepaymentSettings; // not nedded
    };

    vm.applyPrepaymentSettings = function (isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.serverErrors = [];
        vm.formErrors = true;

        return;
      }

      vm.productCategory.prepayment_settings = vm.prepaymentSettings;

      // console.log(vm.productCategory); return;

      vm.sendingPrepaymentSettings = true;
      ProductCategoryService.applyPrepaymentSettings(vm.productCategory).then(function (response) {
        if (response) {
          // Success
          response.prepayment_settings = setPrepaymentSettings();
          vm.onPrepaymentSettingsSaved({ productCategory: response });
        }

        vm.sendingPrepaymentSettings = false;
      });
    };

    vm.isBeforeService = function (prepaymentSetting) {
      if (prepaymentSetting.payment_time === vm.prepaymentPaymentTimes[1].payment_time) {
        prepaymentSetting.days_before_service = prepaymentSetting.days_before_service || 1;

        return true;
      }

      prepaymentSetting.days_before_service = 0;

      return false;
    };

    vm.validateValue = function (prepaymentSetting) {
      prepaymentSetting.value = prepaymentSetting.value || 1;
    };

    vm.validateDays = function (prepaymentSetting) {
      prepaymentSetting.days_before_service = prepaymentSetting.days_before_service || 1;
    };

    // private methods
    // -----------------------
    function setPrepaymentSettings() {
      if (vm.prepaymentSettings.length === 0) {
        vm.prepaymentSettings = [];

        vm.prepaymentSettings.push({
          payment_time: vm.prepaymentPaymentTimes[2].payment_time,
          value: 100,
        });
      } else {
        let onBookingDate;
        let dayBeforeDate;
        let onServiceDate;

        onBookingDate = vm.prepaymentSettings.filter((item) => {
          return item.payment_time === vm.prepaymentPaymentTimes[0].payment_time;
        });

        dayBeforeDate = vm.prepaymentSettings.filter((item) => {
          return item.payment_time === vm.prepaymentPaymentTimes[1].payment_time;
        });

        onServiceDate = vm.prepaymentSettings.filter((item) => {
          return item.payment_time === vm.prepaymentPaymentTimes[2].payment_time;
        });

        onBookingDate.sort((a, b) => {
          return b.value - a.value;
        });

        dayBeforeDate.sort((a, b) => {
          return b.days_before_service - a.days_before_service || b.value - a.value;
        });

        onServiceDate.sort((a, b) => {
          return b.value - a.value;
        });

        vm.sortedItems = [...onBookingDate, ...dayBeforeDate, ...onServiceDate];

        vm.prepaymentSettings = vm.sortedItems;
      }

      let total = 0;

      vm.totalPercentage = vm.prepaymentSettings.forEach((x) => {
        total += parseFloat(x.value || 0);
      });

      vm.totalPercentage = total;

      return vm.prepaymentSettings;
    }
  }
})();
